const SELECTORS = {
  announcement: '[data-bd-announcement]',
  announcementItem: '[data-bd-announcement-item]',
  header: '[data-bd-header]',
  menu: '[data-bd-mobile-nav]',
  menuToggle: '[data-bd-menu-toggle]',
  menuClose: '[data-bd-menu-close]',
};

function initAnnouncement() {
  document.querySelectorAll(SELECTORS.announcement).forEach((bar) => {
    const items = [...bar.querySelectorAll(SELECTORS.announcementItem)];
    if (items.length < 2) return;
    let active = 0;
    const speed = Number.parseFloat(getComputedStyle(bar).getPropertyValue('--bd-rotation')) * 1000 || 5000;
    window.setInterval(() => {
      if (!window.matchMedia('(max-width: 749px)').matches || document.hidden) return;
      items[active].classList.remove('is-active');
      active = (active + 1) % items.length;
      items[active].classList.add('is-active');
    }, speed);
  });
}

function initHeader() {
  document.querySelectorAll(SELECTORS.header).forEach((header) => {
    const menu = header.querySelector(SELECTORS.menu);
    const scrim = header.querySelector('.bd-mobile-nav__scrim');
    const toggle = header.querySelector(SELECTORS.menuToggle);
    if (!menu || !toggle || !scrim) return;

    const setOpen = (open) => {
      menu.hidden = !open;
      scrim.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('bd-menu-open', open);
      if (open) menu.querySelector('a,button,input')?.focus();
    };

    toggle.addEventListener('click', () => setOpen(true));
    header.querySelectorAll(SELECTORS.menuClose).forEach((button) => button.addEventListener('click', () => setOpen(false)));
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setOpen(false); });
    window.addEventListener('resize', () => { if (window.innerWidth >= 990) setOpen(false); }, { passive: true });

    const updateShadow = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    updateShadow();
    window.addEventListener('scroll', updateShadow, { passive: true });

    document.addEventListener('click', (event) => {
      header.querySelectorAll('.bd-mega[open]').forEach((details) => {
        if (!details.contains(event.target)) details.removeAttribute('open');
      });
    });
  });
}

function initReveals() {
  const nodes = [...document.querySelectorAll('.bd-reveal')];
  if (!nodes.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    nodes.forEach((node) => node.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
  nodes.forEach((node) => observer.observe(node));
}

function initEditorReloads() {
  document.addEventListener('shopify:section:load', () => {
    initAnnouncement();
    initHeader();
    initReveals();
  });
}

function boot() {
  initAnnouncement();
  initHeader();
  initReveals();
  initEditorReloads();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
else boot();
